'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _treatInformation = require('./treat-information.component');

var _treatInformation2 = _interopRequireDefault(_treatInformation);

var _productLabelDownload = require('./product-label-download/product-label-download.module');

var _productLabelDownload2 = _interopRequireDefault(_productLabelDownload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.product.treatInformation', [_productLabelDownload2.default]).component('treatInformation', _treatInformation2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/product/information/treat-information.module.js